<script>
import LocalStorageService from '../../services/LocalStorageService'

export default {
  methods: {
    logout () {
      LocalStorageService.deleteAuthorization()
      LocalStorageService.deleteUserDetails()
      this.$router.push('/login')
    }
  },
  created () {
    this.logout()
  },
  render () { return null }
}
</script>
